import { Modal, Tooltip } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledArbitrationModal = styled(Modal)`
  .modal-dialog {
    max-width: 900px;
  }
`

export const StyledArbitrationForm = styled.div`
  font-size: 14px;

  textarea {
    resize: none;
  }

  span {
    white-space: nowrap;
  }

  hr {
    margin: 16px 25px;
  }

  button {
    &:disabled {
      background-color: #e9ecef;
      opacity: 1;
    }
  }

  .arbitration-container {
    display: flex;
    padding: 0 25px;
    min-height: 20px;
    margin-bottom: 4px;
  }

  .arbitration-field {
    width: 50%;
    display: flex;
    padding: 0 20px;

    span {
      width: max-content;
      min-width: 170px;
      font-weight: 600;
    }
  }

  .arbitration-field label {
    min-width: 170px;
    font-weight: 600;
    line-height: 30px;
    margin: 0;
  }

  .arbitration-field input {
    height: 30px;
    padding: 0 8px;
  }

  .arbitration-field .dropdown-container {
    width: 100%;
  }

  .input-context {
    width: 100%;
  }

  .error-label {
    color: red;
    font-size: 12px;
  }

  .info-label {
    color: #6c757d;
    font-size: 13px;
    font-style: italic;
    margin-top: 4px;
  }

  .required-field::after {
    content: ' *';
    color: red;
  }

  .modal-footer {
    padding: 15px 1rem;
  }

  .modal-footer button {
    margin-left: 15px;
  }

  @media (max-width: 1200px) {
    .arbitration-container {
      display: contents;
    }

    .arbitration-field {
      width: 100%;
      margin-bottom: 4px;
    }

    .arbitration-field input {
      margin: 0;
    }

    .modal-footer {
      padding: 15px 1rem;
    }
  }

  @media (max-width: 768px) {
    .arbitration-field {
      display: block;
    }

    .modal-footer {
      padding: 15px 1rem;
    }
  }
`

export const StyledArbitrationFormLoading = styled.div`
  height: 80vh;
  line-height: 80vh;
  text-align: center;
`

export const StyledTooltip = styled(Tooltip)`
  opacity: 1 !important;

  .tooltip-inner {
    color: black;
    font-size: 14px;
    max-width: 500px;
    background-color: white;
    box-shadow: rgb(0 0 0 / 15%) 0px 2px 4px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    text-align: left;
  }

  .arrow::before {
    border-style: none;
  }
`
